import * as core from '../../../../../../../core'
import * as stakeholderAnalysis from '../stakeholder-analysis'

export const RESOURCE = {
  payload: {
    alias: 'details',
    appAlias: stakeholderAnalysis.RESOURCE.payload.alias,
    description: 'See and edit details of a stakeholder',
    display: {
      isMain: false,
      position: 0,
    },
    name: 'Details',
    page: { alias: 'stakeholder.analysis.details' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
